/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Appname1Inputs */

const id_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const ms_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const da_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const de_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const en_us2_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const es_es2_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const es_mx2_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const fil_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const fr_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const it_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const hu_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const nl_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const no_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const pl_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const pt_br2_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const pt_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const ro_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const fi_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const sv_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const vi_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const tr_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const cs_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const bg_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const ru_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const uk_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const ar_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const hi_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const th_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const ja_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const zh_cn2_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const zh_hant1_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

const ko_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA`)
};

/**
* | output |
* | --- |
* | "EGDATA" |
*
* @param {Common_Appname1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const common_appname1 = /** @type {((inputs?: Common_Appname1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Appname1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_common_appname1(inputs)
	if (locale === "ms") return ms_common_appname1(inputs)
	if (locale === "da") return da_common_appname1(inputs)
	if (locale === "de") return de_common_appname1(inputs)
	if (locale === "en-US") return en_us2_common_appname1(inputs)
	if (locale === "es-ES") return es_es2_common_appname1(inputs)
	if (locale === "es-MX") return es_mx2_common_appname1(inputs)
	if (locale === "fil") return fil_common_appname1(inputs)
	if (locale === "fr") return fr_common_appname1(inputs)
	if (locale === "it") return it_common_appname1(inputs)
	if (locale === "hu") return hu_common_appname1(inputs)
	if (locale === "nl") return nl_common_appname1(inputs)
	if (locale === "no") return no_common_appname1(inputs)
	if (locale === "pl") return pl_common_appname1(inputs)
	if (locale === "pt-BR") return pt_br2_common_appname1(inputs)
	if (locale === "pt") return pt_common_appname1(inputs)
	if (locale === "ro") return ro_common_appname1(inputs)
	if (locale === "fi") return fi_common_appname1(inputs)
	if (locale === "sv") return sv_common_appname1(inputs)
	if (locale === "vi") return vi_common_appname1(inputs)
	if (locale === "tr") return tr_common_appname1(inputs)
	if (locale === "cs") return cs_common_appname1(inputs)
	if (locale === "bg") return bg_common_appname1(inputs)
	if (locale === "ru") return ru_common_appname1(inputs)
	if (locale === "uk") return uk_common_appname1(inputs)
	if (locale === "ar") return ar_common_appname1(inputs)
	if (locale === "hi") return hi_common_appname1(inputs)
	if (locale === "th") return th_common_appname1(inputs)
	if (locale === "ja") return ja_common_appname1(inputs)
	if (locale === "zh-CN") return zh_cn2_common_appname1(inputs)
	if (locale === "zh-Hant") return zh_hant1_common_appname1(inputs)
	return ko_common_appname1(inputs)
});
export { common_appname1 as "common.appName" }